var _g, _defs;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLeap = function SvgLeap(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 59,
    viewBox: "0 0 198 59",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4782 0V58.5H84.6603L81.1954 46.8H62.5768V0H54.4782ZM185.602 35.1H173.454L173.328 58.5H165.23V0H185.476C202.091 0 202.3 35.1 185.602 35.1ZM173.454 23.4585L185.602 23.4C191.571 23.4 191.362 11.7 185.476 11.7H173.454V23.4585ZM118.474 11.7V0H86.3302V58.5H118.474V46.8H94.3454V35.1H110.417V23.4H94.3454V11.7H118.474ZM0 0H41.7457V58.5H0V0ZM17.8254 25.155L31.4345 28.0215L33.5636 44.0505L35.5674 20.8845L21.2486 11.7L17.8254 25.155ZM17.8254 25.155L16.7818 29.25L4.46679 46.8585L21.1651 35.9775L24.0455 28.2555L17.8254 25.155ZM154.793 58.5H163.602L146.319 0H137.427L120.144 58.5H128.953L132.417 46.8H151.328L154.793 58.5V58.5ZM135.882 35.1L141.894 14.8005L147.863 35.1H135.882Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 58.5,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/leap.5dfe7fe1.svg";
export { ForwardRef as ReactComponent };